import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as VouchersActions, Selectors as VouchersSelectors } from 'store/ducks/vouchers';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Vouchers/components';

class Edit extends Component {
  state = {
    data: {
      title: '',
      value: '',
      discount: '',
      days_to_expire: '',
      active: false,
      plan_ids: [],
    },
    errors: {},
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Vouchers', to: '/points/vouchers' },
      { name: 'Editar', to: '' },
    ],
  };

  componentDidMount() {
    const { getVoucherRequest } = this.props;
    getVoucherRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { voucher } = this.props;

    if (oldProps.voucher.loading && !voucher.loading) {
      this.setState({
        data: {
          ...data,
          title: voucher.data.attributes.title,
          alias: voucher.data.attributes.alias,
          value: voucher.data.attributes.value,
          discount: voucher.data.attributes.discount,
          days_to_expire: voucher.data.attributes.days_to_expire,
          active: voucher.data.attributes.active,
          plan_ids: voucher.data.attributes.plans.map((plan) => ({
            label: plan.name,
            value: plan.id,
          })),
        },
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, { path: '/points/vouchers/:id/edit' });
    return match.params.id;
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      value: {
        required: true,
      },

      discount: {
        required: true,
      },

      days_to_expire: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { updateVoucherRequest } = this.props;

    updateVoucherRequest(this.handleGetID(), {
      title: data.title,
      value: data.value,
      discount: data.discount,
      days_to_expire: data.days_to_expire,
      active: data.active,
      plan_ids: data.plan_ids ? data.plan_ids.map((plan) => plan.value) : [],
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  voucher: {
    ...state.vouchers.detail,
    data: VouchersSelectors.detail(state.vouchers.detail.data),
  },
  update: state.vouchers.update,
});

const mapActions = dispatch => bindActionCreators(VouchersActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
